import axios from 'axios'
import apis from '../../modules/apis'
import { getJwtToken } from '../../modules/auth'

const TEMP_TOKEN =
  'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJ1c2VyX2lkIjo2OTIsImV4cCI6MTYyMDI1MDk5MzAwMH0.WW0gGWy2TQSoL8maH6DKxH0vYz0Tr-ZHti73jS6DKfcG5xu7rDtgCl6gLVaZ6z-p46kvs5fvmOf15gpfkPdwrLVu8hvoH8pUWTQ7n6UicSBOU4BkjcZeoGi6Aevttm6Y2aEwkmKZaM_c-Nn4NAYPKkwweIKL8Fitrl1Lt_4uFL1G_ksKriHunXyq13YNQRIzYDgMWaF71HM8aKQms19kGlnzNzfn8UK63sK04x1I1tmiP075uehCI3L9SC4bI7JCUn5jVqf_-_ElFkX3J6uEKFdHNH8aHkt2cwuR-SXQh3lSmXsvl5GQVAj99vTfOF66XqVxL-FIxSiPSspd1H5EmA'

const payload = {
  myAnswer: {
    client: 'web',
    role: 0,
    page: '/review/my_answer',
  },
  googleDoc: {
    client: 'web',
    role: 0,
    page: '/review/google_doc',
  },
  review: {
    client: 'web',
    role: 0,
    page: '/review/home',
  },
  feedback: {
    client: 'web',
    role: 0,
    page: '/review/feedback',
  },
  firstLesson: {
    client: 'web',
    role: 0,
    page: '/retention/first_lesson',
  },
  monthLesson: {
    client: 'web',
    role: 0,
    page: '/retention/month_lesson',
  },
}
let intervalFunc = null

export const tracker = (type: string, clear = false) => {
  if (clear && intervalFunc) {
    clearInterval(intervalFunc)
  } else {
    intervalFunc = setInterval(() => {
      axios(apis.lessons.review.postUseAnalysisUrl(), {
        method: 'post',
        headers: {
          Authorization: `Bearer ${type === 'myAnswer' ? TEMP_TOKEN : getJwtToken()}`,
        },
        data: payload[type],
      })
    }, 60000)
  }
}
